/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_CompleteInputs */

const cs_action_complete = /** @type {(inputs: Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončit`)
};

const en_action_complete = /** @type {(inputs: Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Action_CompleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_complete = /** @type {((inputs?: Action_CompleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_CompleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_complete(inputs)
	return cs_action_complete(inputs)
});